/* eslint-disable @typescript-eslint/ban-ts-comment */
import { theme, dark } from '../../stitches.config';
import { fns } from '../functions';
import { colorNameMap } from '../default-colors';
import { colorScheme } from './svelteui.stores';
export function useSvelteUITheme() {
    let observer;
    colorScheme?.subscribe((mode) => {
        observer = mode;
    });
    const DEFAULT_THEME = {
        // @ts-ignore
        ...theme,
        colorNames: colorNameMap,
        colorScheme: observer,
        dark: dark?.selector,
        fn: {
            cover: fns.cover,
            themeColor: fns.themeColor,
            size: fns.size,
            radius: fns.radius,
            rgba: fns.rgba,
            variant: fns.variant
        }
    };
    return DEFAULT_THEME;
}
